require("./o-static-heading.scss");

var $ = require("jquery");

$(window).scroll(function () {
    var scroll = $(window).scrollTop();
    $('.o-static-heading__bg').each(function () {
        var $element = $(this);
        $element.css({
            width: (100 + scroll / 8) + "%"
        });
    });
});


// WEBPACK FOOTER //
// ./Sig.Web/src/atomic/organism/o-static-heading/o-static-heading.chunk.js